import userReducer from './userReducer'
import postsReducer from './postsReducer'

const rootReducer = {
  userReducer,
  postsReducer
};

export default rootReducer
